<template>
  <div>

    <v-fade-transition mode="out-in">
      <v-alert 
        class="my-3"
        v-if="!loading && estimations.length == 0"
        type="info">
        There are no estimations.
      </v-alert>

      <table
        v-if="loading || estimations.length > 0" 
        class="table is-fullwidth is-hoverable is-clickable has-smaller-font">
        <thead>
          <tr>
            <th v-for="(header, i) in headers" :key="i">
              {{ header }}
            </th>
          </tr>
          <tr v-if="loading">
            <th :colspan="headers.length" class="py-0 px-0 is-naked">
              <v-progress class="is-fullwidth" v-model="loading"/>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr 
            v-for="estimation in estimations" 
            :key="estimation.id"
            @click="viewEstimation(estimation)">
            <td>
              {{ estimation.rfq.project.project_name }}
            </td>
            <td>
              <div class="is-size-7">
                {{ estimation.rfq.rfq_name}}
              </div>
              <div class="help has-text-grey text--nowrap">
                Version {{ estimation.rfq.version }}
              </div>
            </td>
            <td>
              <div class="is-size-7">
                {{ estimation.created_user.display_name }}
              </div>
              <div class="help has-text-grey text--nowrap">
                {{ formatDate(parseDate(estimation.created_on)) }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </v-fade-transition>

    <v-pagination 
      class="mt-3"
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>
  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VProgress from '@/components/base/VProgress'
import VAlert from '@/components/base/VAlert'
import VFadeTransition from '@/components/transitions/VFadeTransition'
import { mapState, mapActions, mapMutations } from 'vuex'

import { parseJSON, format } from 'date-fns'

export default {
  props: {
    filters: {
      type: Object
    }
  },
  components: { VPagination, VProgress, VAlert, VFadeTransition },
  data() {
    return {
      headers: ['Project', 'RFQ Name & Version', 'Created By/ On'],
      parseDate: (date) => { return date ? parseJSON(date) : date },
      formatDate: (date) => format(date, "yyyy-MM-dd HH:mm")
    }
  },
  computed: {
    ...mapState("cladifyEstimations", ["estimations", "loading", "pagination"])
  },
  watch: {
    'pagination.page'() {
      let params = { ...this.filters, ...this.pagination };
      this.getEstimations(params);
    },
    filters: {
      handler(filters) {
        let params = { ...filters };
        this.getEstimations(params);
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("cladifyEstimations", ["getEstimations"]),
    ...mapMutations("cladifyEstimations", ["changePage"]),
    initialize() {
      let params = { ...this.filters };
      this.getEstimations(params);
    },
    viewEstimation(estimation) {
      this.$router.push({
        name: `EstimationViewer${estimation.rfq.product_brand}`, 
        params: {
          estimationId: estimation.id
        } 
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>